<template>
  <div>
    <div>
      <!-- page meta -->
      <Head>
        <title>Coach Clients with Platforma</title>
        <link
          rel="icon"
          :href="$filters.public_path('favicon.png')"
          type="favicon"
        />
        <meta
          name="description"
          content="Deliver a premium coaching experience to your clients."
        />
      </Head>
    </div>
    <!-- content start -->

    <div
      class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
    >
      <!-- ===================== HERO SECTION ===================== -->

      <section
        id="section1"
        class="hero-section relative mx-auto mt-[150px] gap-1 bg-transparent lg:flex lg:py-0"
        :style="backgroundImageStyleMain"
      >
        <div class="mt-0 bg-transparent px-[25px] xl:px-0 lg:max-w-[488px]">
          <h1
            class="top-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Your clients and work all in one place.
          </h1>

          <p
            class="mt-[5px] mb-[25px] text-[15px] font-medium text-[#7c828d] lg:text-lg"
          >
            Expand coaching to a whole new level with private coaching chat or
            coach is groups.
          </p>

          <!-- captcher email widget -->

          <EmailCaptureHeaderWidget />

          <img :src="$filters.media_path('/images/stars.svg')" alt="" />
        </div>

        <div class="mb-[30px] mt-[30px] lg:mt-0 z-10">
          <video
            class="lg:max-w-[648px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
            id="home_video"
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/video-call-meetings-in-your-online-course-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>
      </section>

      <div
        class="join-mobile mx-auto mt-[30px] h-[150px] max-w-6xl gap-2 bg-[#f5f8fa] py-[65px] md:mt-[150px] md:flex md:h-auto md:bg-[#fafbfc] md:bg-blend-overlay"
      >
        <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
        <h2
          class="mx-auto px-0 text-center text-[12px] font-[500] text-[#7c828d]"
        >
          JOIN 10,000+ HIGH EARNING BUSINESSES & CREATORS
        </h2>
        <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
      </div>

      <!-- ===================== VIDEO CALLS ===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[50px] lg:flex lg:h-[500px] xl:px-0"
      >
        <img
          class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
          :src="$filters.media_path('/images/blue_gradient.svg')"
          alt=""
        />

        <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
          <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
            <div
              id="text_video_calls"
              class="text-xs font-extrabold text-[#2D8CFF]"
            >
              VIDEO CALLS
            </div>

            <h2
              class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              The future of coaching is here.
            </h2>

            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
            />

            <p
              class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
            >
              Easily Create the perfect coaching platform with nested video
              calls.
              <br /><br />
              Clients log in to your private website and connect with you
              directly getting results in real time.
            </p>
          </div>

          <div class="z-30 mt-[25px] xl:mt-0">
            <img
              loading="lazy"
              class="w-[654px]"
              :src="
                $filters.media_path(
                  '/images/live-streaming-to-members-in-course-members-area.png'
                )
              "
              alt="Best way to monetize social media by moving followers OFF social media."
            />
          </div>
        </div>
      </section>

      <!-- ===================== ENCRYPTED CHAT SECTION ===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[250px] lg:flex lg:h-[500px] lg:flex-row-reverse xl:px-0"
      >
        <img
          class="absolute top-0 right-[600px] z-0 h-[600px] w-[810px] origin-top-left overflow-hidden"
          :src="$filters.media_path('/images/green-diamond-dots-bg.svg')"
          alt=""
        />

        <div
          class="mt-12 text-center lg:mx-0 lg:mt-0 lg:max-w-[500px] lg:px-[30px] lg:text-left"
        >
          <div
            id="text_video_marketing"
            class="text-xs font-extrabold text-[#27AE60] lg:left-0"
          >
            ENCRYPTED CHAT
          </div>

          <h2
            class="top-full px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] md:mt-[20px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Collaborate on ideas together.
          </h2>

          <div class="">
            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#27AE60] lg:ml-0"
            />
          </div>

          <p
            class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
          >
            Advanced encrypted chat creates ongoing engagement. Direct
            instructions using quick voice and video messaging to streamline
            communication.
          </p>
        </div>

        <div
          class="mx-auto mt-12 justify-center gap-1 py-0 md:z-10 lg:mt-0 lg:px-0"
        >
          <video
            class="lg:w-[648px] lg:mt-[30px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
            id="home_video"
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/encrypted-creator-chat-for-subscribers-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>
      </section>

      <!-- ===================== PACKAGE DEALS ===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[200px] lg:flex lg:h-[550px] xl:px-0"
      >
        <img
          class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
          :src="
            $filters.media_path('/images/platforma_turqoise_diamond_bg.svg')
          "
          alt=""
        />

        <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
          <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
            <div
              id="text_automation"
              class="text-xs font-extrabold text-[#49CCF9]"
            >
              PACKAGE DEALS
            </div>

            <h2
              class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              Connect your courses to coaching.
            </h2>

            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#49CCF9] lg:ml-0"
            />

            <p
              class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
            >
              Allow clients to access everything in one place by linking
              programs, courses, and coaching together in one log in. Customize
              web pages and client portal themes—all within your editor.
            </p>
          </div>

          <div class="z-30 mt-[25px] xl:mt-0">
            <img
              loading="lazy"
              class="lg:w-[625px]"
              :src="
                $filters.media_path(
                  '/images/platforma-online-course-builder-for-dancing.png'
                )
              "
              alt="Build Courses with your coaching faster"
            />
          </div>
        </div>
      </section>

      <!-- ===================== FEED SECTION ===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-4 px-[25px] lg:mx-auto lg:mt-[225px] lg:flex lg:h-[500px] lg:flex-row-reverse xl:px-0"
      >
        <img
          class="absolute top-0 right-[600px] z-0 h-[600px] w-[810px] origin-top-left overflow-hidden"
          :src="$filters.media_path('/images/platforma-yellow-diamond.svg')"
          alt=""
        />

        <div
          class="mt-12 text-center lg:mx-0 lg:mt-0 lg:max-w-[500px] lg:px-[30px] lg:text-left"
        >
          <div
            id="text_video_marketing"
            class="text-xs font-extrabold text-[#FFC800] lg:left-0"
          >
            THE FEED
          </div>

          <h2
            class="top-full px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] md:mt-[20px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Group coaching is here with a familiar template.
          </h2>

          <div class="">
            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#FFC800] lg:ml-0"
            />
          </div>

          <p
            class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
          >
            Ongoing group newsfeed similar to Facebook groups allow everyone to
            hear your session and participate.
          </p>
        </div>

        <div
          class="mx-auto mt-12 justify-center gap-1 py-0 md:z-10 lg:mt-0 lg:px-0"
        >
          <video
            class="lg:max-w-[648px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
            id=""
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/social-group-for-marketing-in-course-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>
      </section>

      <!-- ===================== SECURE DATA SECTION ===================== -->
      <section
        class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[350px] lg:flex lg:h-[550px] xl:px-0"
      >
        <img
          class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
          :src="$filters.media_path('/images/platforma-purple-diamond.svg')"
          alt=""
        />

        <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
          <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
            <div
              id="text_secure_data"
              class="text-xs font-extrabold text-[#7B68EE]"
            >
              SECURE DATA
            </div>

            <h2
              class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
            >
              Securely share with anyone.
            </h2>

            <hr
              class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#7B68EE] lg:ml-0"
            />

            <p
              class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
            >
              Transfer personal files easily on private servers that are NOT in
              Amazon or Google Data Centers and susceptible to cancellation by
              the big tech industry.
            </p>
          </div>

          <div class="z-30 mt-[25px] xl:mt-0">
            <img
              loading="lazy"
              class="lg:w-[625px]"
              :src="
                $filters.media_path(
                  '/images/private-encrypted-chat-to-coach-one-on-one.png'
                )
              "
              alt="One-Click upsell to buy and purchase additional digital products content."
            />
          </div>
        </div>
      </section>
    </div>

    <!-- ============= EMAIL INTEGRATIONS ============= -->

    <EmailIntegrationsSlider />

    <!-- ===================== CTA BLOCK ===================== -->
    <CtaBlock
      cta-headline="Coach with Platforma, & crush 
revenue goals every month."
    />
  </div>
</template>

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import Axios from 'axios';
import EmailCaptureHeaderWidget from '../Components/EmailCaptureHeader.vue';
import EmailIntegrationsSlider from '../Components/EmailIntegrationsSlider.vue';
import CtaBlock from '../Components/CtaBlockFooterComponent.vue';

export default {
  layout: DefaultLayout,
  components: {
    // ButtonComponent,
    EmailCaptureHeaderWidget,
    EmailIntegrationsSlider,
    CtaBlock
  },

  computed: {
    backgroundImageStyleMain() {
      const imagePath = this.$filters.media_path(
        'images/platforma-header-background-eclipse.svg'
      );
      return {
        '--before-background-image': `url(${imagePath})`
      };
    }
  }
};
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(42%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.join-mobile {
  background-image: url(../media/images/two-dots.svg);
  background-size: contain;
}
</style>
